import React from 'react';

import moment from 'moment';

import AppBar from 'components/AppBar';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';

import { Title, DateInfo } from './styles';

interface InfoProps {
  destinationPoint?: TravelHotelContentLocationRequest;
  checkInDate?: Date;
  checkOutDate?: Date;
}

interface Props {
  info: InfoProps;
  loading: boolean;
  goBack: () => void;
  onEdit: () => void;
}

const Header = ({ info, loading, goBack, onEdit }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <AppBar goBack={goBack} loading={loading} rightLabel={t('hotelsList.edit')} rightAction={onEdit}>
      <Title>{`${info.destinationPoint && info.destinationPoint.name}`}</Title>
      <DateInfo>
        {moment(info.checkInDate).format('ddd DD[,] MMM')} - {moment(info.checkOutDate).format('ddd DD[,] MMM')}
      </DateInfo>
    </AppBar>
  );
};

export default Header;
